import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout, message } from 'antd';

// 组件
import AppHeader from './components/layout/AppHeader';
import AppFooter from './components/layout/AppFooter';

// 页面
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import EmotionRecordsPage from './pages/EmotionRecordsPage';
import EmotionRecordDetailPage from './pages/EmotionRecordDetailPage';
import CreateEmotionRecordPage from './pages/CreateEmotionRecordPage';
import ProfilePage from './pages/ProfilePage';
import ChatPage from './pages/ChatPage';
import NotFoundPage from './pages/NotFoundPage';

// 数据分析页面
import EmotionAnalyticsPage from './components/analytics/EmotionAnalyticsPage';
import ChatAnalyticsPage from './components/analytics/ChatAnalyticsPage';

// AI助手页面
import EmotionAIChat from './components/ai/EmotionAIChat';
import ChatMCPAssistant from './components/ai/ChatMCPAssistant';

// 上下文
import { useAuth } from './contexts/AuthContext';

const { Content } = Layout;

// 配置全局消息提示
message.config({
  top: 100,
  duration: 2,
  maxCount: 3,
});

// 受保护的路由
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <Layout className="layout" style={{ minHeight: '100vh' }}>
      <AppHeader />
      <Content style={{ padding: '0 50px', marginTop: 64 }}>
        <div className="site-layout-content" style={{ margin: '16px 0' }}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route 
              path="/dashboard" 
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/emotion-records" 
              element={
                <ProtectedRoute>
                  <EmotionRecordsPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/emotion-records/:id" 
              element={
                <ProtectedRoute>
                  <EmotionRecordDetailPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/emotion-records/create" 
              element={
                <ProtectedRoute>
                  <CreateEmotionRecordPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/chat" 
              element={
                <ProtectedRoute>
                  <ChatPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/profile" 
              element={
                <ProtectedRoute>
                  <ProfilePage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/analytics/emotions" 
              element={
                <ProtectedRoute>
                  <EmotionAnalyticsPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/analytics/chats" 
              element={
                <ProtectedRoute>
                  <ChatAnalyticsPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/ai/emotion-assistant" 
              element={
                <ProtectedRoute>
                  <EmotionAIChat />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/ai/chat-mcp-assistant" 
              element={
                <ProtectedRoute>
                  <ChatMCPAssistant />
                </ProtectedRoute>
              } 
            />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </div>
      </Content>
      <AppFooter />
    </Layout>
  );
}

export default App; 